// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GroupOutlinedSvg from "@fishx/icons-svg/es/asn/GroupOutlined";
import FishxIcon from '../components/FishxIcon';

var GroupOutlined = function GroupOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GroupOutlinedSvg
  }));
};

GroupOutlined.displayName = 'GroupOutlined';
export default React.forwardRef(GroupOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GroupOutlined.js
// module id = 2899
// module chunks = 0